<template>
  <div>
    <!--<breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互'},{title:'新人员配置管理'}]"/>-->
    <Breadtabsheader/>
    <div class="h-content">
      <!-- 搜素条件 -->
      <div class="h-piece">
        <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="用户">
              <el-input v-model="q.userName" placeholder="请输入创客名称"></el-input>
            </el-form-item>
            <el-form-item label="部门">
              <el-select filterable v-model="q.dept" clearable placeholder="请选择"
              >
                <el-option
                    v-for="(item,index) in deptList"
                    :key="item.dept"
                    :label="item.dept"
                    :value="item.dept">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="区域">
              <el-select filterable v-model="q.area" clearable placeholder="请选择">
                <el-option
                    v-for="(item,index) in quyuList"
                    :key="item+index"
                    :label="item"
                    :value="item">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="是否日清">
              <el-select v-model="q.isDayClean" :v="q.isDayClean"
                         :clearable="true" placeholder="请选择">
                <el-option label="是" :value="1"></el-option>
                <el-option label="否" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-collapse-transition>
            <div v-show="isScreen">
              <div class="h-thirdColumn w-newColumn">
              <el-form-item label="职务"  prop="title">
						 <el-select v-model="q.titleCode" filterable clearable placeholder="请选择">
							<el-option v-for="(item) in options3" :key="item.code" :label="item.name" :value="item.code">
							</el-option>
						 </el-select>
					    </el-form-item>
               <el-form-item label="渠道名称" prop="channelName">
                    <brselect category="clue_channel" :v="q.channelCode"   placeholder="请选择" v-model="q.channelCode"
                                  :clearable="true"
                                  style="width:100%"/>
              </el-form-item> 
               <el-form-item prop="userType" label="用户类型">
              <el-select v-model="q.userType" :v="q.userType"
                           @change="changUserType($event)" :clearable="true" placeholder="请选择">
                  <el-option label="体验" :value="1"></el-option>
                  <el-option label="抢单" :value="2"></el-option>
                </el-select>
              </el-form-item>
              </div>
            </div>
          </el-collapse-transition>
          <!-- 展开搜素 -->
          <div class="l-screenBox">
            <div class="l-screen" @click="collapseChange">
              <img :src="isScreen?closeScreen:drawScreen" alt="">
              <div class="l-screenText">{{ isScreen ? "收起" : "展开" }}</div>
            </div>
            <div class="l-retrieval">
              <el-button class="h-btn h-formBtn" @click="selectPageAll">检索</el-button>
              <el-button class="h-btn h-formBtn h-bgwhite" @click="rest">重置</el-button>
              <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="create" >
                新建用户
              </el-button>
            </div>
          </div>
        </el-form>
      </div>
      <!-- 结果展示 -->
      <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
        <el-table
            ref="multipleTable"
            :data="tableData"
            :border="true"
            stripe
            max-height="560"
            :span-method="objectSpanMethod"
            style="width: 100%">
          <el-table-column
              label="序号"
              type="index"
              width="50">
          </el-table-column>
          <el-table-column prop="userName" label="用户" min-width="10%"></el-table-column>
          <el-table-column prop="userCode" label="工号" min-width="10%"></el-table-column>
          <el-table-column prop="dept" label="部门" min-width="10%"></el-table-column>
          <el-table-column prop="title" label="职务" min-width="10%"></el-table-column>
          <el-table-column prop="area" label="区域" min-width="10%"></el-table-column>
          <el-table-column prop="userType" label="用户类型" min-width="10%">
            <template slot-scope="scope">
                              <span v-if="scope.row.userType == 1 ">
                                体验
                              </span>
              <span v-if="scope.row.userType == 2 ">
                                抢单
                              </span>
            </template>
          </el-table-column>
          <el-table-column prop="field" label="领域" min-width="10%">
            <template slot-scope="scope">
              <span v-if="scope.row.field == 1 ">
                                医疗
                              </span>
              <span v-if="scope.row.field == 2 ">
                                制药
                              </span>
              <span v-if="scope.row.field == 3 ">
                                高科
                              </span>
              <span v-if="scope.row.field == 4 ">
                                疫苗
                              </span>
              <span v-if="scope.row.field == 5 ">
                                血液
                              </span>
            </template>
          </el-table-column>

          <el-table-column prop="channel" label="渠道" min-width="10%"></el-table-column>
          <el-table-column prop="lianqun" label="链群" min-width="10%">

          </el-table-column>
          <el-table-column prop="isDayClean" label="是否日清" min-width="10%">
            <template slot-scope="scope">
                                  <span v-if="scope.row.isDayClean == 1 ">
                                    是
                                  </span>
              <span v-if="scope.row.isDayClean == 2 && scope.row.isAttendance == 0">
                                    否
                                  </span>
              <span v-if="scope.row.isDayClean == 2 && scope.row.isAttendance == 1">
                                    不考核
                                  </span>
            </template>
          </el-table-column>

          <el-table-column prop="isDefault" label="是否接口人" min-width="10%">
            <template slot-scope="scope">
                <span v-if="scope.row.isDefault == 1 ">
                  是
                </span>
              <span v-if="scope.row.isDefault == 0 ">
                  否
                </span>
            </template>
          </el-table-column>
            <el-table-column prop="isOrder" label="是否填写月度抢单" min-width="10%">
                <template slot-scope="scope">
                <span v-if="scope.row.isOrder == 1 ">
                  是
                </span>
                    <span v-if="scope.row.isOrder == 0 ">
                  否
                </span>
                </template>
            </el-table-column>

          <el-table-column prop="dateState" label="不考核开始时间" min-width="10%"></el-table-column>
          <el-table-column prop="dateEnd" label="不考核结束时间" min-width="10%"></el-table-column>

          <el-table-column
              label="操作"
              fixed="right"
              width="150px">
            <template slot-scope="scope">
              <el-button
                  type="text"
                  size="small"
                  class="h-tableLink h-btn"
                  @click="updateDetail(scope.row)"
              >编辑
              </el-button>
              <el-button
                  type="text"
                  size="small"
                  class="h-tableLink h-btn"
                  @click="deleteSingle(scope.row.userCode,scope.row.userName,scope.row.titleCode)"
              >删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 弹出层 -->
      <el-dialog :close-on-click-modal="false" @close='closeDialog' :visible.sync="newDialog" class="h-dialog2">
        <div class="h-dialogImg">
          <div class="h-disTable">
            <div class="h-tableCell">
              <h1>{{ titleDig }}</h1>
            </div>
          </div>
        </div>
        <div class="h-formLines">
          <div style="padding: 12px;">
            <el-form :model="add" label-position="right" :inline="true" label-width="80"
                     class="demo-ruleForm h-formbLine h-formbLine1" :rules="editFormRules">
              <el-form-item label="用户名称" prop="userName">
                <el-select v-model="add.userName" remote filterable :filter-method="showUserList" placeholder="请输入"
                           :remote-method="showUserList" @change="showUserList" ref="usercode">
                  <el-option v-for="(item,index) in userList"
                             :key="item.username + index"
                             :label="item.username+'-'+item.usercode"
                             :value="item.username + '-' + item.usercode">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="用户编码">
                <el-input v-model="add.userCode" placeholder="自带出" disabled=""></el-input>
              </el-form-item>
              <el-form-item label="职务"  prop="title">
						 <el-select v-model="add.title" filterable clearable placeholder="请选择"  @change="changTitle($event)">
							<el-option v-for="(item) in options3" :key="item.code" :label="item.name" :value="item.code">
							</el-option>
						 </el-select>
					  </el-form-item>
            
              <el-form-item label="区域" prop="area">
                <brselect v-model="add.area" :v="add.area" category="show_area" :clearable="true"
                          @change="changArea($event)"></brselect>
              </el-form-item>

              <!--<el-form-item label="区域" prop="area" v-if="add.titleCode == 'DAQU'">-->
              <!--  <el-select v-model="add.area" :v="add.area"-->
              <!--             @change="changAreaDaqu($event)" :clearable="true" placeholder="请选择" ref="getArea">-->
              <!--    <el-option label="苏皖赣" value="苏皖赣"></el-option>-->
              <!--    <el-option label="京津冀" value="京津冀"></el-option>-->
              <!--    <el-option label="华北" value="华北"></el-option>-->
              <!--    <el-option label="华中" value="华中"></el-option>-->
              <!--    <el-option label="华东" value="华东"></el-option>-->
              <!--    <el-option label="西南" value="西南"></el-option>-->
              <!--    <el-option label="西北" value="西北"></el-option>-->
              <!--    <el-option label="华南" value="华南"></el-option>-->
              <!--    <el-option label="东北" value="东北"></el-option>-->
              <!--  </el-select>-->
              <!--</el-form-item>-->

              <el-form-item prop="dept" label="部门">
                <el-select filterable v-model="add.dept" clearable placeholder="请选择" @change="changDept($event)"
                >
                  <el-option
                      v-for="(item,index) in deptList"
                      :key="item.dept"
                      :label="item.dept"
                      :value="item">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item prop="userType" label="用户类型">
                <el-select v-model="add.userType" :v="add.userType"
                           @change="changUserType($event)" :clearable="true" placeholder="请选择">
                  <el-option label="体验" :value="1"></el-option>
                  <el-option label="抢单" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="isDayClean" label="是否日清">
                <el-select v-model="add.isDayClean" :v="add.isDayClean"
                           @change="changIsDayClean($event)" :clearable="true" placeholder="请选择">
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="2"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="是否接口人">
                <el-select v-model="add.isDefault">
                  <el-option
                      v-for="item in StatusOptions"
                      :key="item.key"
                      :value="item.key"
                      :label="item.display_name"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="是否填写月度抢单">
                <el-select v-model="add.isOrder">
                    <el-option
                        v-for="item in StatusOptions"
                        :key="item.key"
                        :value="item.key"
                        :label="item.display_name"
                    />
                </el-select>
              </el-form-item>

              <el-form-item label="不考核开始时间" prop="dateState" v-if="add.isDayClean == '1'">
                <el-date-picker
                    v-model="add.dateState"
                    :picker-options="pickeroptions"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="不考核结束时间" prop="dateEnd" v-if="add.isDayClean == '1'">
                <el-date-picker
                    v-model="add.dateEnd"
                    :picker-options="pickeroptions"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
              <br>
              <el-form-item prop="lianqun" label="链群" v-if="add.titleCode=='LIANQUN'">
                <el-checkbox-group v-model="add.lianqunCheckList"  style="width: 500px">
                  <el-checkbox v-for="(item,index) in  xsybLianqunList" :key="index" :label="item" :value="item"
                               style="margin-left: 20px">{{ item }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>

              <el-form-item prop="field" label="领域以及渠道" style="width: 600px" v-if="add.titleCode != 'LIANQUN'">
                <el-checkbox-group v-model="add.fieldList" style="width: 600px">

                  <el-checkbox label="1" value="1" style="display: inline-block;" @change="fieldChange(1)">医疗
                  </el-checkbox>
                  <el-checkbox-group v-model="add.checkTypeList1">
                    <el-checkbox @change="qudaoChange(1)" v-for="(item,index) in fieldQudaoList1" :key="index"
                                 :label="item" :value="item" style="margin-left: 30px">{{ item }}
                    </el-checkbox>
                  </el-checkbox-group>

                  <el-checkbox  label="2" value="2" style="display: inline-block" @change="fieldChange(2)">制药
                  </el-checkbox>
                  <el-checkbox-group v-model="add.checkTypeList2">
                    <el-checkbox @change="qudaoChange(2)" v-for="(item,index) in fieldQudaoList2" :key="index"
                                 :label="item" :value="item" style="margin-left: 30px">{{ item }}
                    </el-checkbox>
                  </el-checkbox-group>

                  <el-checkbox label="3" value="3" style="display: inline-block" @change="fieldChange(3)">高科
                  </el-checkbox>
                  <el-checkbox-group  v-model="add.checkTypeList3">
                    <el-checkbox @change="qudaoChange(3)" v-for="(item,index) in fieldQudaoList3" :key="index"
                                 :label="item" :value="item" style="margin-left: 30px">{{ item }}
                    </el-checkbox>
                  </el-checkbox-group>

                  <el-checkbox label="4" value="4" style="display: inline-block" @change="fieldChange(4)">疫苗
                  </el-checkbox>
                  <el-checkbox-group v-model="add.checkTypeList4">
                    <el-checkbox @change="qudaoChange(4)" v-for="(item,index) in fieldQudaoList4" :key="index"
                                 :label="item" :value="item" style="margin-left: 30px">{{ item }}
                    </el-checkbox>
                  </el-checkbox-group>

                  <el-checkbox label="5" value="5" style="display: inline-block" @change="fieldChange(5)">血液
                  </el-checkbox>
                  <el-checkbox-group v-model="add.checkTypeList5">
                    <el-checkbox @change="qudaoChange(5)" v-for="(item,index) in fieldQudaoList5" :key="index"
                                 :label="item" :value="item" style="margin-left: 30px">{{ item }}
                    </el-checkbox>
                  </el-checkbox-group>
                </el-checkbox-group>
              </el-form-item>

            </el-form>
          </div>
          <div style="display:flex;justify-content:center;margin-bottom:20px">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCreate()">提交</el-button>
          </div>
        </div>
      </el-dialog>
      <!-- 编辑 -->
      <el-dialog :close-on-click-modal="false" @close='closeDialog' :visible.sync="editDialog" class="h-dialog2"  >
        <div class="h-dialogImg">
          <div class="h-disTable">
            <div class="h-tableCell">
              <h1>{{ titleDig }}</h1>
            </div>
          </div>
        </div>
        <div class="h-formLines">
          <div style="padding: 12px;">
            <el-form :model="add" label-position="right" :inline="true" label-width="80"
                     class="demo-ruleForm h-formbLine h-formbLine1" :rules="editFormRules">
              <el-form-item label="用户名称" prop="userName">
                <el-select v-model="add.userName" remote filterable :filter-method="showUserList" placeholder="请输入"
                           :remote-method="showUserList" @change="showUserList">
                  <el-option v-for="(item,index) in userList"
                             :key="item.username + index"
                             :label="item.username+'-' + item.usercode"
                             :value="item.username + '-' + item.usercode">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="userCode" label="用户编码">
                <el-input v-model="add.userCode" placeholder="自带出" disabled=""></el-input>
              </el-form-item>
            <el-form-item label="职务"  prop="title">
						 <el-select v-model="add.title" filterable clearable disabled="true" placeholder="请选择"  @change="changArea($event)">
							<el-option v-for="(item) in options3" :key="item.code" :label="item.name" :value="item.code">
							</el-option>
						 </el-select>
              </el-form-item>

              <el-form-item label="区域" prop="area" v-if="add.titleCode != 'DAQU'">
                <brselect v-model="add.area" :v="add.area" category="show_area" :clearable="true"
                          @change="changArea($event)"></brselect>
              </el-form-item>

              <el-form-item label="区域" prop="area" v-if="edit.titleCode == 'DAQU'">
                <el-select v-model="add.area" :v="add.area"
                           :clearable="true" @change="changAreaDaqu($event)" placeholder="请选择">
                  <el-option label="苏皖赣" value="苏皖赣"></el-option>
                  <el-option label="京津冀" value="京津冀"></el-option>
                  <el-option label="华北" value="华北"></el-option>
                  <el-option label="华中" value="华中"></el-option>
                  <el-option label="华东" value="华东"></el-option>
                  <el-option label="西南" value="西南"></el-option>
                  <el-option label="西北" value="西北"></el-option>
                  <el-option label="华南" value="华南"></el-option>
                  <el-option label="东北" value="东北"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="dept" label="部门">
                <el-select filterable v-model="add.dept" clearable placeholder="请选择" @change="changDept($event)"
                >
                  <el-option
                      v-for="(item,index) in deptList"
                      :key="item.dept"
                      :label="item.dept"
                      :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="userType" label="用户类型">
                <el-select v-model="add.userType" :v="add.userType" @change="changUserType($event)"
                           :clearable="true" placeholder="请选择">
                  <el-option label="体验" :value="1"></el-option>
                  <el-option label="抢单" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="isDayClean" label="是否日清">
                <el-select v-model="add.isDayClean" :v="add.isDayClean"
                           @change="changIsDayClean($event)" :clearable="true" placeholder="请选择">
                  <el-option label="是" :value="1"></el-option>
                  <el-option label="否" :value="2" v-if="this.add.isAttendance == 0 "></el-option>
                  <el-option label="(否)不考核" :value="2" v-if="this.add.isAttendance == 1 "></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="是否接口人">
                <el-select v-model="add.isDefault">
                  <el-option
                      v-for="item in StatusOptions"
                      :key="item.key"
                      :value="item.key"
                      :label="item.display_name"
                  />
                </el-select>
              </el-form-item>
                <el-form-item label="是否填写月度抢单">
                    <el-select v-model="add.isOrder">
                        <el-option
                            v-for="item in StatusOptions"
                            :key="item.key"
                            :value="item.key"
                            :label="item.display_name"
                        />
                    </el-select>
                </el-form-item>

              <el-form-item label="不考核开始时间" prop="dateState" v-if="add.isDayClean == '1' || add.isAttendance == '1'">
                <el-date-picker
                    v-model="add.dateState"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickeroptions"
                    placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="不考核结束时间" prop="dateEnd" v-if="add.isDayClean == '1' || add.isAttendance == '1'">
                <el-date-picker
                    v-model="add.dateEnd"
                    :picker-options="pickeroptions"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
              <br>
              <el-form-item prop="lianqun" label="链群" v-if="add.titleCode=='LIANQUN'">
                <el-checkbox-group v-model="add.lianqunCheckList" style="width: 500px">
                  <el-checkbox v-for="(item,index) in  xsybLianqunList" :key="index" :label="item" :value="item"
                               style="margin-left: 20px">{{ item }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item prop="field" label="领域以及渠道" style="width: 600px" v-if="add.titleCode != 'LIANQUN'">

                <el-checkbox-group v-model="add.fieldList" style="width: 600px">
                  <el-checkbox label="1" value="1" style="display: inline-block;" @change="fieldChange(1)">医疗
                  </el-checkbox>
                  <el-checkbox-group v-model="add.checkTypeList1">
                    <el-checkbox @change="qudaoChange(1)" v-for="(item,index) in fieldQudaoList1" :key="index"
                                 :label="item" :value="item" style="margin-left: 30px">{{ item }}
                    </el-checkbox>
                  </el-checkbox-group>

                  <el-checkbox  label="2" value="2" style="display: inline-block" @change="fieldChange(2)">制药
                  </el-checkbox>
                  <el-checkbox-group v-model="add.checkTypeList2">
                    <el-checkbox @change="qudaoChange(2)" v-for="(item,index) in fieldQudaoList2" :key="index"
                                 :label="item" :value="item" style="margin-left: 30px">{{ item }}
                    </el-checkbox>
                  </el-checkbox-group>

                  <el-checkbox label="3" value="3" style="display: inline-block" @change="fieldChange(3)">高科
                  </el-checkbox>
                  <el-checkbox-group v-model="add.checkTypeList3">
                    <el-checkbox @change="qudaoChange(3)" v-for="(item,index) in fieldQudaoList3" :key="index"
                                 :label="item" :value="item" style="margin-left: 30px">{{ item }}
                    </el-checkbox>
                  </el-checkbox-group>

                  <el-checkbox label="4" value="4" style="display: inline-block" @change="fieldChange(4)">疫苗
                  </el-checkbox>
                  <el-checkbox-group v-model="add.checkTypeList4">
                    <el-checkbox @change="qudaoChange(4)" v-for="(item,index) in fieldQudaoList4" :key="index"
                                 :label="item" :value="item" style="margin-left: 30px">{{ item }}
                    </el-checkbox>
                  </el-checkbox-group>

                  <el-checkbox label="5" value="5" style="display: inline-block" @change="fieldChange(5)">血液
                  </el-checkbox>
                  <el-checkbox-group v-model="add.checkTypeList5">
                    <el-checkbox @change="qudaoChange(5)" v-for="(item,index) in fieldQudaoList5" :key="index"
                                 :label="item" :value="item" style="margin-left: 30px">{{ item }}
                    </el-checkbox>
                  </el-checkbox-group>

                </el-checkbox-group>
              </el-form-item>
            </el-form>
          </div>
          <div style="display:flex;justify-content:center;margin-bottom:20px">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCreate()">修改</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
    <div class="h-tableB h-mrt30">
      <!--        <div class="h-tableBL" style="margin-left: 23px">-->
      <!--          <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"-->
      <!--                     @click="exportExcel">批量导出-->
      <!--          </el-button>-->
      <!--        </div>-->
      <div class="h-pagination2">
        <pagination :page="q" @query="selectPageAll"/>
      </div>
    </div>
  </div>
</template>
<script>
import ss from "../../../api/SystemService";
import updownfile from '../../../utils/updownfile'
import util from "../../../utils/util";
import customerDetailsService from "../../../api/loud/credit/customerDetailsService";
import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
import cost from '../../../routes/cost';

export default {
  data() {
    return {
      q: {
        userName: '',
        titleCode: '',
        isDayClean: '',
        dept: '',
        area: '',
        pageNo: 1,
        pageSize: 10,
        total: 0,
        channelCode:'',
        userType:''

      },
      size: '',
      spanArr: [],
      tableData: [],
      newDialog: false,
      writeNissin: false,
      editDialog: false,
      // 展开折叠筛选
      isScreen: false,
      titleDig: '',
      yearList: [new Date().getFullYear(), new Date().getFullYear() + 1],
      userList: [],
      deptList: [],
      qudaoList: [],
      fieldQudaoList1: [],
      fieldQudaoList2: [],
      fieldQudaoList3: [],
      fieldQudaoList4: [],
      fieldQudaoList5: [],
      lianqunList: [],
      xsybLianqunList: [],
      quyuList: [],
      options2: [],
      options3: [],
      StatusOptions : [
        { key: 0, display_name: '否' },
        { key: 1, display_name: '是' }, ],

      closeScreen: require("@/assets/images/pimg/closeallic.png"),
      drawScreen: require("@/assets/images/pimg/dobleArr.png"),
      add: {
        id: '',
        checkTypeList1: [],
        checkTypeList2: [],
        checkTypeList3: [],
        checkTypeList4: [],
        checkTypeList5: [],
        lianqunCheckList: [],
        fieldList: [],
        userCode: '',
        userName: '',
        userType: '',
        dept: '',
        deptCode: '',
        title: '',
        titleCode: '',
        area: '',
        areaCode: '',
        channel: '',
        channelCode: '',
        isDayClean: '',
        dateState: '',
        dateEnd: '',
        isAttendance: '',
        lianqunList: '',
        isDefault: '', //是否默认接口人
        isOrder: '' //是否需要填写网络月度订单
      },
      edit: {
        id: '',
        userCode: '',
        userName: '',
        userType: '',
        dept: '',
        deptCode: '',
        title: '',
        titleCode: '',
        area: '',
        areaCode: '',
        channel: '',
        channelCode: '',
        isDayClean: '',
        dateState: '',
        dateEnd: '',
        isAttendance: '',
        fieldList: [],
        checkTypeList1: [],
        checkTypeList2: []

      },
      editFormRules: {
        userName: [{required: true, message: '请输入必填项', trigger: 'blur'}],
        title: [{required: true, message: '请输入必填项', trigger: 'blur'}],
        dept: [{required: true, message: '请输入必填项', trigger: 'blur'}],
        area: [{required: true, message: '请输入必填项', trigger: 'blur'}],
        channel: [{required: true, message: '请输入必填项', trigger: 'blur'}],
        userType: [{required: true, message: '请输入必填项', trigger: 'blur'}],
        isDayClean: [{required: true, message: '请输入必填项', trigger: 'blur'}],
      },
      pickeroptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      }
    }
  },
  methods: {
    //明细导出
    exportExcel() {
      updownfile.down("/api/swyl/v1/dailyClear/userDailyClear/newDownloadExcel", this.q, "post", 'data');
    },
    getOption() {
      this.optionList = []
      var data = ''
      ss.MuBiao.getUser(data).then(res => {
        console.log(res)
        this.optionList = res.msg
      })
    },
    getDept(q) {
      ss.MuBiao.getDeptList(q).then(rd => {
        this.deptList = rd;
      })
    },
    getQudao() {
      debugger
      ss.MuBiao.getFeildQudaoMap().then(rd => {
        console.log(rd)
        this.fieldQudaoList1 = rd.obj[1];
        this.fieldQudaoList2 = rd.obj[2];
        this.fieldQudaoList3 = rd.obj[3];
        this.fieldQudaoList4 = rd.obj[4];
        this.fieldQudaoList5 = rd.obj[5];
      })
    },
    getLianqunList() {
      ss.MuBiao.getLianqunList().then(rd => {
        this.xsybLianqunList = rd.obj;
      })
    },
    commitUpdate() {
      var data = {
        id: this.edit.id,
        userCode: this.edit.userCode,
        userName: this.edit.userName,
        userType: this.edit.userType,
        dept: this.edit.dept,
        deptCode: this.edit.deptCode,
        title: this.edit.title,
        titleCode: this.edit.titleCode,
        area: this.edit.area,
        areaCode: this.edit.areaCode,
        channel: this.edit.channel,
        channelCode: this.edit.channelCode,
        isDayClean: this.edit.isDayClean,
        dateState: this.edit.dateState,
        dateEnd: this.edit.dateEnd,
        isAttendance: this.edit.isAttendance,
      }
      console.log("data", data)
      ss.MuBiao.newDayCleanConfigUpdateById(data).then(res => {
        console.log(res)
        if (res.f == true) {
          this.editDialog = false
          console.log(res)
          this.$message({
            message: res.msg,
            type: 'success'
          });
          this.selectPageAll()
          this.newDialog = false
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    updateDetail(row) {
      this.authTypeListEdit = []
      this.titleDig = "编辑内容"
      var data1 = row.userName;
      var data2 = row.userCode;
      var data3 = row.titleCode;

      // this.add.checkTypeList1 = [];
      // this.add.checkTypeList2 = [];
      // this.add.checkTypeList3 = [];
      // this.add.checkTypeList4 = [];
      // this.add.checkTypeList5 = [];
      debugger
      ss.MuBiao.newDayCleanConfigSelectById(data1,data2,data3).then(res => {
        console.log(res)
        this.add.id = res.obj.id
        this.add.userCode = res.obj.userCode,
            this.add.userName = res.obj.userName,
            this.add.userType = res.obj.userType,
            this.add.dept = res.obj.dept,
            this.add.deptCode = res.obj.deptCode,
            this.add.title = res.obj.title,
            this.add.titleCode = res.obj.titleCode,
            this.add.area = res.obj.area,
            this.add.areaCode = res.obj.areaCode,
            // this.add.channel = res.obj.channel,
            // this.edit.channelCode = res.obj.channelCode,
            this.add.isDayClean = res.obj.isDayClean,
            this.add.dateState = res.obj.dateState,
            this.add.dateEnd = res.obj.dateEnd,
            this.add.isAttendance = res.obj.isAttendance,
            this.add.checkTypeList1 = res.obj.checkTypeList1,
            this.add.checkTypeList2 = res.obj.checkTypeList2,
            this.add.checkTypeList3 = res.obj.checkTypeList3,
            this.add.checkTypeList4 = res.obj.checkTypeList4,
            this.add.checkTypeList5 = res.obj.checkTypeList5,

            this.add.fieldList = res.obj.fieldList,
            this.add.lianqunCheckList = res.obj.lianqunCheckList,
            this.add.isDefault = res.obj.isDefault
            this.add.isOrder = res.obj.isOrder

           
      })
      this.editDialog = true
    },
    querySearchGroup(queryString, cb) {
      var groupArr = this.groupArr;
      cb(groupArr);
    },
    selectGroup(val) {
      console.log(val)
      this.add.customerName = val.value
    },
    groupListMe1() {
      var data = this.edit.customerName
      ss.MuBiao.getUser(data).then(res => {
        console.log(res)
        this.groupList = []
        this.groupArr = []
        this.groupList = res.msg
        for (let item of this.groupList) {
          this.groupArr.push({
            value: item.userName,
            id: item.userCode
          })
        }
      })
    },
    changAreaDaqu(v) {
      if (v == '苏皖赣') {
        this.add.areaCode = 'SU_WAN_GAN';
      }
      if (v == '京津冀') {
        this.add.areaCode = 'JING_JIN_JI';
      }
      if (v == '华北') {
        this.add.areaCode = 'HUA_BEI';
      }
      if (v == '华中') {
        this.add.areaCode = 'HUA_ZHONG';
      }
      if (v == '华东') {
        this.add.areaCode = 'HUA_DONG';
      }
      if (v == '西南') {
        this.add.areaCode = 'XI_NAN';
      }
      if (v == '西北') {
        this.add.areaCode = 'XI_BEI';
      }
      if (v == '东北') {
        this.add.areaCode = 'DONG_BEI';
      }
      if(v=='华南'){
        this.add.areaCode = 'HUA_NAN';
      }


    },
    querySearchGroup1(queryString, cb) {
      var groupArr = this.groupArr;
      cb(groupArr);
    },
    selectGroup1(val) {
      console.log(val)
      this.edit.customerName = val.value
    },
    commitCreate() {
      console.log(this.add)
      debugger
      var data = {
        id: this.add.id,
        userCode: this.add.userCode,
        userName: this.add.userName,
        userType: this.add.userType,
        dept: this.add.dept,
        deptCode: this.add.deptCode,
        title: this.add.title,
        titleCode: this.add.titleCode,
        area: this.add.area,
        areaCode: this.add.areaCode,
        channel: this.add.channel,
        channelCode: this.add.channelCode,
        isDayClean: this.add.isDayClean,
        dateState: this.add.dateState,
        dateEnd: this.add.dateEnd,
        isAttendance: this.add.isAttendance,
        field: this.add.field,
        lianqunCheckList: this.add.lianqunCheckList,
        checkTypeList: this.add.checkTypeList,
        checkTypeList1: this.add.checkTypeList1,
        checkTypeList2: this.add.checkTypeList2,
        checkTypeList3: this.add.checkTypeList3,
        checkTypeList4: this.add.checkTypeList4,
        checkTypeList5: this.add.checkTypeList5,
        fieldList: this.add.fieldList,
        isDefault: this.add.isDefault,
        isOrder: this.add.isOrder,
      }
      if (this.add.id == null || this.add.id == '') {
        ss.MuBiao.newDayCleanConfigInsert(data).then(res => {
          console.log(res)
          if (res.f == true) {
            console.log(res)
            this.$message({
              message: res.msg,
              type: 'success'
            });
            this.selectPageAll()
            //this.newDialog = false
            this.closeDialog()
          } else {
            this.$message.error(res.msg);
          }
        })
      } else {
        ss.MuBiao.newDayCleanConfigUpdateById(data).then(res => {
          console.log(res)
          if (res.f == true) {
            this.editDialog = false
            console.log(res)
            this.$message({
              message: res.msg,
              type: 'success'
            });
            this.selectPageAll()
            this.newDialog = false
          } else {
            this.$message.error(res.msg);
          }
        })
      }

    },
    changeHandler(value) {
      //console.log('改变之后的值是:' + value)
      let data = this.authTypeList
      let item = this.add.userList
      // 使用find方法根据id查询对应对象
      let a = data.find((ele) => {
        return ele.id == item
      });
      console.log(a) //1
      var arr3 = a
      if (!arr3.id) {
        this.add.targetContent = '',
            this.add.customerName = ''
        this.add.clearType = 2
        this.disEdit = true
      } else {
        this.add.targetContent = arr3.targetContent,
            this.add.customerName = arr3.customerName
        this.add.clearType = 1
        this.add.projectName = arr3.projectName
        this.disEdit = false
        this.add.id = this.add.userList
      }
    },


    deleteSingle(id,userName,titleCode) {
      //
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ss.MuBiao.newDayCleanConfigDeleteById(id,userName,titleCode).then(res => {
          console.log(res)
          if (res.f == true) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.selectPageAll();
          } else {
            this.$message.error(res.msg);
          }
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    selectPageAll() {
      console.log(this.q);
      ss.MuBiao.newCheckPageDayClean(this.q).then(res => {
        console.log(res.msg)
        this.tableData = res.records
        this.q.total = res.total
        this.getSpanArr();
      })

    },
    getNowTime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      month = month + 1;
      month = month.toString().padStart(2, "0");
      date = date.toString().padStart(2, "0");
      var defaultDate = `${year}-${month}-${date}`;
      this.$set(this.q, "visitDate", defaultDate);
      this.$set(this.add, "visitDateNew", defaultDate);
    },

    changIsDayClean(res) {
      this.add.isDayClean = res
      this.edit.isDayClean = res

      this.edit.dateEnd = ''
      this.edit.dateState = ''
      this.edit.isAttendance = '0'

      // if(res == 2){
      //
      //   this.edit.dateEnd = ''
      //   this.edit.dateState = ''
      // }

    },
    changUserType(res) {
      console.log(res)
      this.add.userType = res
      this.edit.userType = res
    },
      //职位修改方法
      changTitle(res) {
      console.log(res,"11111")
      console.log(this.add.title)
      if(res){
        for(var i = 0;i<this.options3.length;i++){
          if(this.options3[i].code == res ){
            this.add.title = this.options3[i].name
            this.edit.title = this.options3[i].name
            continue
          }
        }
      this.add.titleCode = res
      this.edit.titleCode = res
   
      }
      this.add.area = ''
      this.add.areaCode = ''
      this.edit.area = ''
      this.edit.areaCode = ''
      this.edit.channel = ''
      this.add.channel = ''
      this.edit.channelCode = ''
      this.add.channelCode = ''
      this.edit.lianqunList = []
      this.add.lianqunList = []
    },
    changDept(res) {
      console.log(res)
      this.add.deptCode = res.deptCode
      this.add.dept = res.dept

      this.edit.deptCode = res.deptCode
      this.edit.dept = res.dept
    },
    changQudao(res) {
      console.log(res)
      this.add.channelCode = res.code
      this.edit.channelCode = res.code

      this.add.channel = res.name
      this.edit.channel = res.name
    },
    changArea(res) {
      console.log(res)
      this.add.areaCode = res.code
      this.add.area = res.name
      this.edit.areaCode = res.code
      this.edit.area = res.name
    },
    changLianqun(res) {
      console.log(res)
      this.add.lianqunCode = res.code
      this.add.lianqun = res.name
      this.edit.lianqunCode = res.code
      this.edit.lianqun = res.name
    },
    //新增日清
    create() {
      this.lianqunList = this.$store.getters.dictlist("xsyb_lianqun");
      this.newDialog = true;
      this.titleDig = "新建用户";
      this.add.isDefault = 0
      this.add.isOrder = 0
    },
    getQuyu(q) {
      ss.MuBiao.getQuyuList(q).then(rd => {
        console.log("area", rd)
        this.quyuList = rd;
      })
    },
    zhiwu(){
      //加载角色
      var ishanyou = this.$store.getters.hasRole('new_person');
      console.log(ishanyou,'1115484512');
      //加载职务
      this.options2 = this.$store.getters.dicts["crm_renyuan"];
      //判断是否有次角色
      if(ishanyou){
      for(var i=0; i<this.options2.length;i++){
        if( this.options2[i].code == 'QUYU' || this.options2[i].code == 'QUDAO') {
          this.options3.push(this.options2[i]);
        }
      }
    }else{
      this.options3 = this.options2;
    }
    },
   
    // 展开折叠
    collapseChange() {
      this.isScreen = !this.isScreen;
    },
    exit() {
      this.closeDialog()
    },
    rest() {
      var pageSize = this.q.pageSize;
      var pageNo = this.q.pageNo;
      var total = this.q.total;
      this.q = {
        pageSize: pageSize,
        pageNo: pageNo,
        total: total,
        userName: '',
        titleCode: '',
        isDayClean: '',
        dept: '',
      }
    },
    closeDialog() {
      this.newDialog = false
      this.editDialog = false
      this.writeNissin = false
      this.xxx = '';//清空数据

      this.add.userCode = '',
          this.add.userName = '',
          this.add.userType = '',
          this.add.dept = '',
          this.add.deptCode = '',
          this.add.title = '',
          this.add.titleCode = '',
          this.add.area = '',
          this.add.areaCode = '',
          this.add.channel = '',
          this.add.channelCode = '',
          this.add.isDayClean = '',
          this.add.isDefault = ''
          this.add.isOrder = ''
          this.add.checkTypeList1 =[],
          this.add.checkTypeList2= [],
          this.add.checkTypeList3= [],
          this.add. checkTypeList4= [],
          this.add.checkTypeList5= [],
          this.add.fieldList = []
    },
    showUserList(value) {
      this.userList = []
      ss.MuBiao.selectUser(value).then(res => {
        console.log(value)
        console.log(res.obj)
        this.userList = res.obj
        // 获取下拉框的label值 以为下拉框的label属于拼接字符串 需要截取数字部分进行判断
        let valueCode = this.$refs.usercode.selected.label.split('-')[1];
        res.obj.forEach( el =>{
          if( el.usercode == valueCode ) {
            this.add.userCode = el.usercode
          }
        })
        //
      })
    },
    objectSpanMethod({row, column, rowIndex, columnIndex}) {

      if (column.label != '序号' &&
          column.label != '渠道' &&
          column.label != '领域' &&
          column.label != '链群' &&
          column.label != '区域'
      ) {

        const _row = this.spanArr[rowIndex];
        console.log(_row + "-----------------")
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        }
      } else {
        return [1, 1]
      }
    },
    qudaoChange(v) {
      if (v == 1) {
        if (this.add.checkTypeList1 != null && this.add.checkTypeList1.length > 0 && this.add.fieldList.indexOf("1") == -1) {
          this.add.fieldList.push("1");
        } else if (this.add.checkTypeList1 != null && this.add.checkTypeList1.length == 0 && this.add.fieldList.indexOf("1") != -1) {
          for (let i = 0; i < this.add.fieldList.length; i++) {
            if (this.add.fieldList[i] == "1") {
              this.add.fieldList.splice(i, 1);
            }
          }
        }
      } else if (v == 2) {
        if (this.add.checkTypeList2 != null && this.add.checkTypeList2.length > 0 && this.add.fieldList.indexOf("2") == -1) {
          this.add.fieldList.push("2");
        } else if (this.add.checkTypeList2 != null && this.add.checkTypeList2.length == 0 && this.add.fieldList.indexOf("2") != -1) {
          for (let i = 0; i < this.add.fieldList.length; i++) {
            if (this.add.fieldList[i] == "2") {
              this.add.fieldList.splice(i, 1);
            }
          }
        }
      }else if (v == 3) {
        if (this.add.checkTypeList3 != null && this.add.checkTypeList3.length > 0 && this.add.fieldList.indexOf("3") == -1) {
          this.add.fieldList.push("3");
        } else if (this.add.checkTypeList3 != null && this.add.checkTypeList3.length == 0 && this.add.fieldList.indexOf("3") != -1) {
          for (let i = 0; i < this.add.fieldList.length; i++) {
            if (this.add.fieldList[i] == "3") {
              this.add.fieldList.splice(i, 1);
            }
          }
        }
      }else if (v == 4) {
        if (this.add.checkTypeList4 != null && this.add.checkTypeList4.length > 0 && this.add.fieldList.indexOf("4") == -1) {
          this.add.fieldList.push("4");
        } else if (this.add.checkTypeList4 != null && this.add.checkTypeList4.length == 0 && this.add.fieldList.indexOf("4") != -1) {
          for (let i = 0; i < this.add.fieldList.length; i++) {
            if (this.add.fieldList[i] == "4") {
              this.add.fieldList.splice(i, 1);
            }
          }
        }
      }else if (v == 5) {
        if (this.add.checkTypeList5 != null && this.add.checkTypeList5.length > 0 && this.add.fieldList.indexOf("5") == -1) {
          this.add.fieldList.push("5");
        } else if (this.add.checkTypeList5 != null && this.add.checkTypeList5.length == 0 && this.add.fieldList.indexOf("5") != -1) {
          for (let i = 0; i < this.add.fieldList.length; i++) {
            if (this.add.fieldList[i] == "5") {
              this.add.fieldList.splice(i, 1);
            }
          }
        }
      }
      console.log(this.add.checkTypeList2);
      console.log(this.add.checkTypeList1);
    },
    fieldChange(v) {
      debugger
      if (v == 1 && this.add.fieldList != null && this.add.fieldList.indexOf("1") == -1) {
        this.add.checkTypeList1 = [];
      } else if(v == 2 && this.add.fieldList != null && this.add.fieldList.indexOf("2") == -1) {
        this.add.checkTypeList2 = [];
      }else if (v == 3 && this.add.fieldList != null && this.add.fieldList.indexOf("3") == -1){
        this.add.checkTypeList3 = [];
      }else if (v == 4 && this.add.fieldList != null && this.add.fieldList.indexOf("4") == -1){
        this.add.checkTypeList4 = [];
      }else if (v == 5 && this.add.fieldList != null && this.add.fieldList.indexOf("5") == -1){
        this.add.checkTypeList5 = [];
      }
      console.log(this.add.fieldList.indexOf("5"));

    },
    getSpanArr() {
      this.spanArr = [];
      this.tableData.forEach((item, index) => {
        if (index === 0) {
          this.spanArr.push(1);
          this.position = 0;
        } else {
          if ((this.tableData[index].userCode == this.tableData[index - 1].userCode) &&
              (this.tableData[index].dept == this.tableData[index - 1].dept) &&
              (this.tableData[index].title == this.tableData[index - 1].title)
          ) {
            this.spanArr[this.position] += 1;
            this.spanArr.push(0);
            console.log(1)
          } else {
            this.spanArr.push(1);
            this.position = index;
            console.log(2)
          }
        }
      })
      console.log(this.spanArr)
    }
  },
  watch: {
    'add.customerName': {
      deep: true,
      handler: function (newVal, oldVal) {
        this.groupArr = [];//这是定义好的用于存放下拉提醒框中数据的数组
        var len = this.groupList.length;//groupList
        var arr = [];
        for (var i = 0; i < len; i++) {//根据输入框中的值进行模糊匹配
          if (this.groupList[i].name.indexOf(this.add.customerName) >= 0) {
            arr.push({
              value: this.groupList[i].name,
              id: this.groupList[i].id
            })
          }
        }
        this.groupArr = arr
      }
    },
  },
  created() {
    this.zhiwu();
    this.getQuyu();
    this.getQudao();
    this.getDept();
    this.getLianqunList();
    this.getNowTime();
    this.getOption();
    this.selectPageAll();
    this.add.year = this.yearList[0]
    this.getProject();
 
  }
}
</script>
<style scoped>
/deep/ .h-formbLine .el-form-item__label {
  width: 80px;
}

/deep/ .h-formbLine .el-form-item__content {
  width: 150px;
}

/deep/ .h-elformWrap-1 .el-form-item__content {
  width: 78%;
}

.projectCon p {
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  border-bottom: #1b78e6 1px dashed;
  padding: 5px 0;
  margin: 0 auto 10px auto;
  color: #1b78e6;
}
</style>
